// SPDX-License-Identifier: AGPL-3.0-or-later
import {parseMarkdownAst} from '@app/vendor/markdown_parser/parser/ParserEngine';
import type {Node} from '@app/vendor/markdown_parser/types/Nodes';
export class Parser {
	private readonly input: string;
	private readonly parserFlags: number;
	constructor(input: string, flags: number) {
		this.input = input;
		this.parserFlags = flags;
	}
	parse(): {
		nodes: Array<Node>;
	} {
		return parseMarkdownAst(this.input, this.parserFlags);
	}
}
